module.exports = __webpack_public_path__ + "media/images/features/support/bg-dotted-9122b0c96554ae9cb7ca770e0e97e541.svg";